type Props = {
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseOut: () => void;
  title: string;
  rectX: number;
  rectY: number;
  rectWidth: number;
  rectHeight: number;
  color: string;
};

const PrefectureButton = ({
  onClick,
  onMouseEnter,
  onMouseOut,
  title,
  rectX,
  rectY,
  rectWidth,
  rectHeight,
  color,
}: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter
          id={`filter-${title}`}
          x={rectX - 1}
          y={rectY - 1}
          width={rectWidth + 5}
          height={rectHeight + 5}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_880:90412" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_880:90412"
            result="shape"
          />
        </filter>
      </defs>
      <g
        filter={`url(#filter-${title})`}
        className="area-group cursor-pointer"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseOut={onMouseOut}
        x={rectX}
        y={rectY}
        width={rectWidth}
        height={rectHeight}
      >
        <rect x={rectX} y={rectY} width={rectWidth} height={rectHeight} rx="2.5" fill="white" />
        <rect x={rectX} y={rectY} width={rectWidth} height={rectHeight} rx="2.5" stroke="#E7E7E7" />
        <svg x={rectX} y={rectY} width={rectWidth} height={rectHeight} pointerEvents="none">
          <text
            x="50%"
            y="50%"
            fontWeight="bold"
            fontSize="18"
            dominantBaseline="middle"
            textAnchor="middle"
            fill={color}
          >
            {title}
          </text>
        </svg>
      </g>
    </svg>
  );
};

export default PrefectureButton;
